import { StaffCatalogOption, StaffType } from '../models/staff.model';
import { StaffApiPaginationMeta } from './staff-vigente-api.types';
import { StaffCatalogApiResponse } from './staff-catalog-api.types';

export const MAX_CATALOG_PAGE_SIZE = 100;

export function toCatalogQueryParams(
  type: StaffType,
  page: number = 1,
): Record<string, string | number> {
  return { tipo: type, page, limit: MAX_CATALOG_PAGE_SIZE };
}

export function hasMorePages(meta: StaffApiPaginationMeta): boolean {
  return meta.page < meta.totalPaginas;
}

export function toCatalogOptions<T>(
  response: StaffCatalogApiResponse<T>,
  toOption: (item: T) => StaffCatalogOption,
): StaffCatalogOption[] {
  return response.data.map(toOption);
}
